import type { BoardAssetType } from '@/open-api/model';
import type { AssetGroup, AssetType } from '@/types/asset';
import { ASSET_TYPE } from '@/types/asset';

export const getBoardAssetTypeFromAssetGroup = (
  assetGroup: AssetGroup
): BoardAssetType => {
  switch (assetGroup.type) {
    case 'sfx':
      return 'Sfx';
    case 'motion':
      return 'MotionGraphics';
    case 'stock_footage':
      return 'Video';
    default:
      return 'Music';
  }
};

const boardAssetTypeToAssetTypeMap: Record<BoardAssetType, AssetType> = {
  Music: ASSET_TYPE.MUSIC,
  Sfx: ASSET_TYPE.SFX,
  MotionGraphics: ASSET_TYPE.MOTION,
  Video: ASSET_TYPE.STOCK_VIDEO,
};

export const boardAssetTypeToAssetType = (
  boardAssetType: BoardAssetType
): AssetType => boardAssetTypeToAssetTypeMap[boardAssetType];
